import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { MainLayout } from '../../components/Layout/MainLayout';
import { CompanyListView } from '../../components/Company/CompanyListView';
import { usePublicCompanies } from '../../hooks/usePublicCompanies';

const CompanyListPage: React.FC = () => {
  const navigate = useNavigate();
  const { companies, loading, error } = usePublicCompanies(100);

  const handleDetailsClick = useCallback(
    (companyId: number) => {
      navigate(`/companies/${companyId}/profile`, {
        state: { from: 'companies' },
      });
    },
    [navigate]
  );

  return (
    <MainLayout>
      <CompanyListView
        companies={companies}
        loading={loading}
        error={error}
        onDetailsClick={handleDetailsClick}
        title="企業一覧"
        subtitle="気になる企業のプロフィールをチェックしましょう"
      />
    </MainLayout>
  );
};

export default CompanyListPage;
